import React, { useEffect, useState } from 'react'
import { CategoryMenu } from 'components/categoryMenu'
import { categoryDefinitions, categoryNames } from 'lib/categories'
import { textToClassName } from 'lib/textToClassName'
import { HotelCategory } from 'components/hotelCategory'
import { useInView } from 'react-intersection-observer'
import { Hotel } from 'data/rating.json'

interface Props {
  rankingTable: Hotel[]
}

export function Ranking({ rankingTable }: Props) {
  const [currentCategory, setCurrentCategory] = useState<string>('none')
  const [ref, inView] = useInView({ rootMargin: '-25%' })

  useEffect(() => {
    if (!inView) {
      setCurrentCategory('none')
    }
  }, [inView])

  return (
    <main ref={ref}>
      <CategoryMenu
        activeCategory={currentCategory}
        categories={categoryDefinitions}
      />
      {categoryNames.map(category => {
        const hotels = rankingTable.filter(
          hotel => hotel.Kategorie === category
        )
        const shortVersion = categoryDefinitions[category].shortName || category
        const cleanedShortVersion = textToClassName(shortVersion)

        return (
          <HotelCategory
            key={cleanedShortVersion}
            categoryTitle={category}
            {...categoryDefinitions[category]}
            id={cleanedShortVersion}
            hotelList={hotels}
            currentCategorySetter={setCurrentCategory}
          />
        )
      })}
    </main>
  )
}
